// import React, { useEffect, useState } from "react";
// import { useFetcher, useLocation, useNavigate } from "react-router-dom";
// import axios from "axios";
// import Swal from "sweetalert2"; // Import SweetAlert
// import InputField from './InputField';
// import Button from './Button';
// import Card from './Card';

// const OtpSignin = () => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const phone= atob(sessionStorage.getItem('mobile'));

//   const [otpInput, setOtpInput] = useState("");
//   const [error, setError] = useState("");

//   const handleOtpChange = (e) => {
//     setOtpInput(e.target.value);
//     setError("");
//   };

//   const handleSubmit = async (e) => {
//     // alert(phone)
//     e.preventDefault();
//     // const storedOtp = window.otp;

//     // if (parseInt(otpInput, 10) !== storedOtp) {
//     //   setError("Incorrect OTP");
//     //   Swal.fire({
//     //     icon: "error",
//     //     title: "Invalid OTP",
//     //     text: "The OTP you entered is incorrect. Please try again.",
//     //     confirmButtonText: "OK",
//     //   });
//     //   return;
//     // }

//     try {
//       // Fetch profession details from the backend
//       const { data } = await axios.post("/professions/get_profession_details", {
//         phone,
//       });

//       if (data.success) {
//         // Display dropdown with profession names
//         const { professionList } = data;
//         const { value: selectedProfession } = await Swal.fire({
//           title: "Select Profession",
//           input: "select",
//           inputOptions: professionList.reduce((options, prof) => {
//             options[prof.profession_id] = prof.profession_name;
//             return options;
//           }, {}),
//           inputPlaceholder: "Select your profession",
//           showCancelButton: true,
//           confirmButtonText: "Continue",
//         });

//         if (selectedProfession) {
//           sessionStorage.setItem("profession_id",selectedProfession);
//           // Navigate to dashboard with the selected profession
//           // navigate("/dashboard", { state: { profession_id: selectedProfession } });
//           navigate("/dashboard");
//         }
//       } else {
//         Swal.fire({
//           icon: "error",
//           title: "Error",
//           text: data.message || "Unable to fetch profession details.",
//           confirmButtonText: "OK",
//         });
//       }
//     } catch (err) {
//       console.error(err);
//       Swal.fire({
//         icon: "error",
//         title: "Error",
//         text: "An error occurred while verifying OTP. Please try again.",
//         confirmButtonText: "OK",
//       });
//     }
//   };

//   return (
//     <div className="relative min-h-screen">
//       {/* Background Image */}
//       <img
//         src="/bg_image.jpg"
//         alt="Background"
//         className="absolute inset-0 object-cover w-full h-full z-0 filter grayscale hover:grayscale-0"
//       />
//       {/* Gray Overlay */}
//       <div className="absolute inset-0 bg-gray-700 opacity-50 z-10" />
//       {/* Content */}
//       <div className="relative min-h-screen flex items-center justify-center z-20">
//         <Card>
//           <img src="/jci_logo.png" alt="Logo" className="w-24 mx-auto mb-6" />
//           <h2 className="card-header">Verify OTP</h2>
//           <p className="text-center text-gray-600 mb-6">
//             Enter the OTP sent to {phone}
//           </p>
//           <form onSubmit={handleSubmit}>
//             <InputField
//               label="OTP"
//               type="text"
//               name="otp"
//               value={otpInput}
//               onChange={handleOtpChange}
//               className="block w-full p-3 border rounded mb-4"
//               placeholder="Enter OTP"
//               required
//             />
//             {error && <p className="text-red-500 text-sm mb-4">{error}</p>}
//             <Button label="Verify and Login" type="submit" />
//           </form>
//         </Card>
//       </div>
//     </div>
//   );
// };

// export default OtpSignin;

import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2"; // Import SweetAlert
import InputField from "./InputField";
import Button from "./Button";
import Card from "./Card";

const OtpSignin = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const phone = atob(sessionStorage.getItem("mobile"));

  const [otpInput, setOtpInput] = useState("");
  const [error, setError] = useState("");

  const handleOtpChange = (e) => {
    setOtpInput(e.target.value);
    setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // Send OTP and phone number to the backend for validation
      const response = await axios.post("/member/validate_otp", {
        phone,
        otp: otpInput,
      });

      if (response.data.success) {
        // OTP is valid; fetch profession details
        const { data } = await axios.post(
          "/professions/get_profession_details",
          {
            phone,
          }
        );

        if (data.success) {
          const { professionList } = data;

          // Show profession dropdown
          const { value: selectedProfession } = await Swal.fire({
            title: "Select Profession",
            input: "select",
            inputOptions: professionList.reduce((options, prof) => {
              options[prof.profession_id] = prof.profession_name;
              return options;
            }, {}),
            inputPlaceholder: "Select your profession",
            showCancelButton: true,
            confirmButtonText: "Continue",
          });

          if (selectedProfession) {
            sessionStorage.setItem("profession_id", selectedProfession);

            if (selectedProfession === "4") {
              // Navigate to trainer-specific status
              const trainerResponse = await axios.get(
                "/member/get_member_by_profession",
                {
                  params: {
                    profession_id: selectedProfession,
                    contact_number: phone,
                  },
                }
              );

              if (trainerResponse.data.success) {
                const { zone_trainer_status } = trainerResponse.data;

                if (zone_trainer_status === "unapproved") {
                  Swal.fire(
                    "Information!",
                    "Kindly await approval from the admin.",
                    "success"
                  ).then(() => navigate("/"));
                } else {
                  navigate("/trainersEventStatus");
                }
              } else {
                Swal.fire({
                  icon: "error",
                  title: "Error",
                  text:
                    trainerResponse.data.message || "Unable to fetch details.",
                  confirmButtonText: "OK",
                });
              }
            } else if (
              selectedProfession === "1" ||
              selectedProfession === "2"
            ) {
              navigate("/AdminApprovedZoneTrainer");
            } else {
              navigate("/lompresidentEventStatus");
            }
          }
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: data.message || "Unable to fetch profession details.",
            confirmButtonText: "OK",
          });
        }
      } else {
        // OTP is invalid
        Swal.fire({
          icon: "error",
          title: response.data.message,
          text: "The OTP you entered is incorrect. Please try again.",
          confirmButtonText: "OK",
        });
      }
    } catch (err) {
      console.error(err);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "An error occurred while verifying OTP. Please try again.",
        confirmButtonText: "OK",
      });
    }
  };

  return (
    <div className="relative min-h-screen">
      {/* Background Image */}
      <img
        src={`${process.env.PUBLIC_URL}/bg_image.jpg`}
        alt="Background"
        className="absolute inset-0 object-cover w-full h-full z-0 filter grayscale hover:grayscale-0"
      />
      {/* Gray Overlay */}
      <div className="absolute inset-0 bg-gray-700 opacity-50 z-10" />
      {/* Content */}
      <div className="relative min-h-screen flex items-center justify-center z-20">
        <Card>
          <img
            src={`${process.env.PUBLIC_URL}/jci_logo.png`}
            alt="Logo"
            className="w-24 mx-auto mb-6"
          />
          <h2 className="card-header">Verify OTP</h2>
          <p className="text-center text-gray-600 mb-6">
            Enter the OTP sent to {phone}
          </p>
          <form onSubmit={handleSubmit}>
            <InputField
              label="OTP"
              type="text"
              name="otp"
              value={otpInput}
              onChange={handleOtpChange}
              className="block w-full p-3 border rounded mb-4"
              placeholder="Enter OTP"
              required
            />
            {error && <p className="text-red-500 text-sm mb-4">{error}</p>}
            <Button label="Verify and Login" type="submit" />
          </form>
        </Card>
      </div>
    </div>
  );
};

export default OtpSignin;
